import axios from '@axios'

export default {
  namespaced: true,
  actions: {

    listContainers(ctx, params) {
      return new Promise((resolve, reject) => {
        axios.get('containers', {params})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },


    fetchContainer(ctx,id) {
      return new Promise((resolve, reject) => {
        axios.get(`containers/${id}/edit`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },


    getContainersCategories(ctx) {
      return new Promise((resolve, reject) => {
        axios.get('getContainersCategories')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    getTypesOptionsBy(ctx, category) {
      return new Promise((resolve, reject) => {
        axios.get('form/getTypesOptionsBy', { params: { category}})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    createContainer(ctx, form) {
      return new Promise((resolve, reject) => {
        axios.post('containers', form)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },


    updateContainer(ctx, {id, form}) {
      return new Promise((resolve, reject) => {
        axios.put(`containers/${id}`, form)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

  },
}
